<fieldset>
	<legend>Initial</legend>
	<fieldset>
		<legend>natureMarche</legend>
		<app-typeFNS-simple-desc-marche
			[uid]="getUid()"
			[parentForm]="parentForm"
			
			[disabled]="disabled"
			[natureMarche]="initialFromFNSimple.natureMarche"
		></app-typeFNS-simple-desc-marche>
	</fieldset>

	<!---->

	<fieldset>
		<legend>informComplementaire</legend>
		<app-type-oui-non-inform-complementaire
			[uid]="getUid()"
			[parentForm]="parentForm"
			
			[disabled]="disabled"
			[informComplementaire]="initialFromFNSimple.informComplementaire"
		></app-type-oui-non-inform-complementaire>
	</fieldset>

	<!---->

	<fieldset>
		<legend>procedure</legend>
		<app-type-procFNS
			[uid]="getUid()"
			[parentForm]="parentForm"
			
			[disabled]="disabled"
			[procedure]="initialFromFNSimple.procedure"
		></app-type-procFNS>
	</fieldset>

	<!---->

	<fieldset>
		<legend>communication</legend>
		<app-communicationFNS-simple
			[uid]="getUid()"
			[parentForm]="parentForm"
			
			[disabled]="disabled"
			[communication]="initialFromFNSimple.communication"
		></app-communicationFNS-simple>
	</fieldset>

	<!---->

	<fieldset>
		<legend>lots</legend>
		<app-type-lotsFNS-simple
			[uid]="getUid()"
			[parentForm]="parentForm"
			
			[disabled]="disabled"
			[initial]="initialFromFNSimple"
		></app-type-lotsFNS-simple>
	</fieldset>
</fieldset>
